var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/placeholder/components/placeholder_media_gallery.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.take.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
export default class PlaceholderMediaGallery extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      width: this.props.defaultWidth
    });
    _defineProperty(this, "handleRef", node => {
      if (node) {
        this.setState({
          width: node.offsetWidth
        });
      }
    });
    _defineProperty(this, "getSizeData", size => {
      const {
        defaultWidth
      } = this.props;
      const width = this.state.width || defaultWidth;
      const style = {};
      let itemsDimensions = [];
      if (size === 1) {
        style.height = width * 9 / 16;
        itemsDimensions = [{
          w: '100%',
          h: '100%'
        }];
      } else if (size === 2) {
        style.height = width / 2;
        itemsDimensions = [{
          w: '50%',
          h: '100%',
          r: '2px'
        }, {
          w: '50%',
          h: '100%',
          l: '2px'
        }];
      } else if (size === 3) {
        style.height = width;
        itemsDimensions = [{
          w: '50%',
          h: '50%',
          b: '2px',
          r: '2px'
        }, {
          w: '50%',
          h: '50%',
          b: '2px',
          l: '2px'
        }, {
          w: '100%',
          h: '50%',
          t: '2px'
        }];
      } else if (size >= 4) {
        style.height = width;
        itemsDimensions = [{
          w: '50%',
          h: '50%',
          b: '2px',
          r: '2px'
        }, {
          w: '50%',
          h: '50%',
          b: '2px',
          l: '2px'
        }, {
          w: '50%',
          h: '50%',
          t: '2px',
          r: '2px'
        }, {
          w: '50%',
          h: '50%',
          t: '2px',
          l: '2px'
        }];
      }
      return ImmutableMap({
        style,
        itemsDimensions,
        size,
        width
      });
    });
    _defineProperty(this, "renderItem", (dimensions, i) => {
      const width = dimensions.w;
      const height = dimensions.h;
      const top = dimensions.t || 'auto';
      const right = dimensions.r || 'auto';
      const bottom = dimensions.b || 'auto';
      const left = dimensions.l || 'auto';
      const float = dimensions.float || 'left';
      const position = dimensions.pos || 'relative';
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "media-gallery__item",
        style: {
          position,
          float,
          left,
          top,
          right,
          bottom,
          height,
          width
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 82,
          columnNumber: 12
        }
      });
    });
  }
  render() {
    const {
      media
    } = this.props;
    const sizeData = this.getSizeData(media.size);
    return /*#__PURE__*/React.createElement("div", {
      className: "media-gallery media-gallery--placeholder",
      style: sizeData.get('style'),
      ref: this.handleRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 7
      }
    }, media.take(4).map((_, i) => this.renderItem(sizeData.get('itemsDimensions')[i], i)));
  }
}
_defineProperty(PlaceholderMediaGallery, "propTypes", {
  media: ImmutablePropTypes.map.isRequired,
  defaultWidth: PropTypes.number
});